import moment from 'moment';
import bindEvents from './events';
import startTabs from './components/main-tabs';
import startVideoPlayer from './videoPlayer';
import appState from './constants';
import '../styles/main.scss';

/**
 *
 */
function checkForHash() {
  const hasHash = window.location.hash;
  if (hasHash) {
    const teamToFind = hasHash.replace('#', '').toLowerCase();
    const teams = JSON.parse($('[data-teams-object]').attr('data-teams-object').toLowerCase()); // eslint-disable-line
    if (teams[teamToFind]) {
      $('.choose-team-list .teams-list').find(`[data-team-id="${teams[teamToFind]}"]`).click();
    }
  }
}

(($) => {
  $(document).ready(() => {
    startTabs();

    const analyticsUA = { // eslint-disable-line
      ge: 'UA-296593-9',
      sportv: 'UA-16233545-1',
    };

    ga('create', analyticsUA.ge, 'auto'); // eslint-disable-line
    bindEvents();
    startVideoPlayer();

    $('.teams-list .escudo').each(function eachTeam() {
      appState.teamsInMenu.push({
        id: $(this).attr('data-team-id'),
        name: $(this).attr('data-name'),
        shield: $(this).attr('data-escudo'),
        initials: $(this).attr('data-initials'),
      });
    });

    const isNewTag = '<span class="player-is-new">novo</span>';
    $('.transaction-row-container').each(function eachElement() {
      const $newContainer = $(this).find('.player-is-new-container');
      const lastUpdate = $(this).attr('data-ultima-atualizacao');

      if (moment().diff(moment(lastUpdate), 'days') <= 0) {
        $newContainer.html(isNewTag);
      }
    });
  });

  $(window).bind('load', () => {
    checkForHash();
  });
})(jQuery);

/* istanbul ignore if */
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/main.js